import { Component, OnInit,ViewChild } from '@angular/core';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import { ToastrService } from 'ngx-toastr';
import {Router} from '@angular/router';



@Component({
  selector: 'app-relatiesview',
  templateUrl: './relatiesview.component.html',
  styleUrls: ['./relatiesview.component.less']
})

export class RelatiesviewComponent implements OnInit {




  dataSource: any =  new MatTableDataSource([{'BedrijfNummer': 'Loading', 'BedrijfsNaam': 'Loading', 'Afkorting': 'Loading', 'Straat':'Loading'}]);;
  displayedColumns: string[] = ['Afkorting', 'BedrijfsNaam', 'Straat', 'BedrijfNummer'];


  constructor(private relatiesService: RelatiesService,
              private toastr: ToastrService,
              private router: Router
      ) { }

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  ngOnInit() {
    this.setActive(true)
  }

  selectRow(row) {
    //console.log(row);
    //alert("Editing " + row.BedrijfNummer)
    //this.toastr.error("Editing " + row.BedrijfNummer, "Not yet implemented");
    this.router.navigateByUrl('/relaties/' + row.BedrijfNummer);
}

  applyFilter(target: any) {
    const element = target as HTMLInputElement
    this.dataSource.filter = element.value.trim().toLowerCase();
  }

  addNew() {
    this.router.navigateByUrl('/relaties/add');
  }

  setActive(active: boolean) {
    this.relatiesService.getList(active).subscribe(o => {
      this.dataSource = new MatTableDataSource(o);
      this.dataSource.sort = this.sort;
    }
    );
  }

}
